import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import './Login.css'

function Login() {
  const navigate = useNavigate()
  const { handleLogin, handleCompleteNewPassword, needsNewPassword, error } = useAuth()
  const [credentials, setCredentials] = useState({ email: '', password: '' })
  const [newPassword, setNewPassword] = useState('')
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [loginError, setLoginError] = useState('')

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setCredentials({ ...credentials, [name]: value })
    setLoginError('')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setLoginError('')

    const result = await handleLogin(credentials.email, credentials.password)
    
    if (result.success) {
      navigate('/')
    } else if (!result.needsNewPassword) {
      setLoginError(result.error || 'Error al iniciar sesión')
    }
    
    setIsLoading(false)
  }

  const handleNewPasswordSubmit = async (e) => {
    e.preventDefault()
    setLoginError('')

    if (newPassword !== newPasswordConfirm) {
      setLoginError('Las contraseñas no coinciden')
      return
    }
    if (newPassword.length < 8 || !/[A-Z]/.test(newPassword) || !/[a-z]/.test(newPassword) || !/[0-9]/.test(newPassword)) {
      setLoginError('La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula y un número')
      return
    }

    setIsLoading(true)
    const result = await handleCompleteNewPassword(newPassword)
    if (result.success) {
      navigate('/')
    } else {
      setLoginError(result.error || 'Error al cambiar contraseña')
    }
    setIsLoading(false)
  }

  if (needsNewPassword) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <div className="logo-circle">
              <span className="logo-icon">🌱</span>
            </div>
            <h1>Cambiar Contraseña</h1>
            <p>Debés establecer una nueva contraseña</p>
          </div>

          <form onSubmit={handleNewPasswordSubmit} className="login-form">
            {loginError && (
              <div className="error-message">{loginError}</div>
            )}

            <div className="form-group">
              <label htmlFor="newPassword">Nueva Contraseña</label>
              <input
                type="password"
                id="newPassword"
                required
                autoComplete="new-password"
                placeholder="••••••••"
                value={newPassword}
                onChange={(e) => { setNewPassword(e.target.value); setLoginError(''); }}
                disabled={isLoading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="newPasswordConfirm">Confirmar Contraseña</label>
              <input
                type="password"
                id="newPasswordConfirm"
                required
                autoComplete="new-password"
                placeholder="••••••••"
                value={newPasswordConfirm}
                onChange={(e) => { setNewPasswordConfirm(e.target.value); setLoginError(''); }}
                disabled={isLoading}
              />
            </div>

            <p style={{ fontSize: '0.8rem', color: '#94a3b8', margin: '0 0 1rem' }}>
              Mínimo 8 caracteres, una mayúscula, una minúscula y un número
            </p>

            <button type="submit" className="login-button" disabled={isLoading}>
              {isLoading ? 'Cambiando...' : 'Cambiar Contraseña'}
            </button>
          </form>
        </div>
      </div>
    )
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="logo-circle">
            <span className="logo-icon">🌱</span>
          </div>
          <h1>GrowPro Admin</h1>
          <p>Panel de Administración</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {(loginError || error) && (
            <div className="error-message">
              {loginError || error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              required
              autoComplete="email"
              placeholder="admin@growpro.club"
              value={credentials.email}
              onChange={handleInputChange}
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              name="password"
              required
              autoComplete="current-password"
              placeholder="••••••••"
              value={credentials.password}
              onChange={handleInputChange}
              disabled={isLoading}
            />
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>

        <div className="login-footer">
          <p>Solo usuarios con permisos de administrador</p>
          <Link to="/revendedor" className="reseller-apply-cta">
            ¿Querés ser revendedor? Postulate acá
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Login
